import isUndefined from 'lodash/isUndefined';
import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '@spothero/ui/carousel';
import CarouselSlide from '@spothero/ui/carousel-slide';
import CarouselSlides from '@spothero/ui/carousel-slides';
import Image from '@spothero/ui/image';
import CloudinaryImage from 'common/image/CloudinaryImage';

const SpotImagesMobile = ({
    images,
    alt,
    lazyLoad,
    width,
    height,
    showArrows,
    showDots,
    transition
}) => {
    return (
        <div className="SpotImages">
            {images.length > 0 &&
                <Carousel
                    transition={transition}
                    showArrows={showArrows}
                    showDots={showDots}
                    lazyLoad={lazyLoad}
                    preload={false}
                >
                    <CarouselSlides>
                        {images.map((image, index) => {
                            return (
                                <CarouselSlide key={index}>
                                    {!isUndefined(image.id) &&
                                        <CloudinaryImage
                                            height={height}
                                            width={width}
                                            index={index}
                                            cloudinaryImageId={image.id}
                                            alt={alt}
                                        />
                                    }
                                    {isUndefined(image.id) &&
                                        <Image
                                            className="cld-hidpi"
                                            height={height}
                                            width={width}
                                            data-index={index}
                                            src={image.src}
                                            alt={image.alt}
                                        />
                                    }
                                </CarouselSlide>
                            );
                        })}
                    </CarouselSlides>
                </Carousel>
            }
        </div>
    );
};

SpotImagesMobile.propTypes = {
    images: PropTypes.array.isRequired,
    alt: PropTypes.string,
    lazyLoad: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    showArrows: PropTypes.bool,
    showDots: PropTypes.bool,
    transition: PropTypes.oneOf(['none', 'slide', 'fade'])
};

SpotImagesMobile.defaultProps = {
    lazyLoad: true,
    width: 320,
    height: 220,
    showArrows: false,
    showDots: true,
    transition: 'slide'
};

export default SpotImagesMobile;
